package com.milta.feature.profile.domain.usecase

import com.milta.feature.profile.domain.repository.ProfileRepository

class RequestAccountDeletionUseCase(private val repository: ProfileRepository) {
    suspend operator fun invoke(): Result<Unit> = repository.requestAccountDeletion()
}
